import React, { useContext } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import CustomContext from '../../context/CustomContext';
import { AuthorityType, ProviderAuthType } from '../../model/types';

/**
 * This component represents a protected route. It redirect to the landing page if the user is not authorized to view a route.
 * @param props - the route props
 */
const ProtectedRoute: React.FC<Props> = (props: Props) => {
    const context = useContext(CustomContext);
    const { authorities, initialized, providerAuths } = props;
    const { auth, providerAuths: contextProviderAuths } = context;

    const deeplink = sessionStorage.getItem('deeplink');
    if (auth && auth.initialized && deeplink) {
        sessionStorage.removeItem('deeplink');
        return <Redirect to={deeplink} />;
    } else if (auth && auth.initialized && !authorities && areProvidersConnected(contextProviderAuths, providerAuths)) {
        return <Route {...props} />;
    } else if (
        auth &&
        auth.initialized &&
        authorities &&
        auth.authorities.some((a) => authorities.includes(a)) &&
        areProvidersConnected(contextProviderAuths, providerAuths)
    ) {
        return <Route {...props} />;
    } else if (auth && !auth.initialized && initialized && areProvidersConnected(contextProviderAuths, providerAuths)) {
        return <Route {...props} />;
    } else if (auth && auth.initialized && !areProvidersConnected(contextProviderAuths, providerAuths)) {
        return <Redirect to="/" />;
    } else if (auth && !auth.initialized) {
        return <Redirect to="/login-error" />;
    } else {
        return <Redirect to="/login" />;
    }
};
export default ProtectedRoute;

export const ProtectedAdminRoute: React.FC<Props> = (props) => {
    return <ProtectedRoute {...props} authorities={['ROLE_ADMIN']} />;
};
export const ProtectedUserRoute: React.FC<Props> = (props) => {
    return <ProtectedRoute {...props} authorities={['ROLE_ADMIN', 'ROLE_USER']} />;
};

const areProvidersConnected = (
    contextProviderAuths: ProviderAuthType[],
    providerAuths?: ProviderAuthType[],
): boolean => {
    let providerAuthsConnected: boolean = false;
    if (!providerAuths || providerAuths.length === 0) {
        providerAuthsConnected = true;
    } else if (providerAuths.some((p) => contextProviderAuths.includes(p))) {
        providerAuthsConnected = true;
    }
    return providerAuthsConnected;
};

interface Props extends RouteProps {
    authorities?: AuthorityType[];
    initialized?: boolean;
    providerAuths?: ProviderAuthType[];
}
